/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ReactNode } from "react";
import styled from "styled-components";
import { Button, Text, theme } from "@nordcloud/gnui";

type WrapperProps = {
  active: boolean;
};

const Wrapper = styled(Button)<WrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 8rem;
  padding: ${theme.spacing.spacing04};
  border: 1px solid ${theme.color.background.ui04};
  transition: ${theme.transition};
  background-color: ${({ active }) =>
    active ? theme.color.background.ui04 : theme.color.background.ui03};
  border-color: ${({ active }) =>
    active ? theme.color.border.focus : theme.color.border.border01};

  &:hover {
    filter: none;
    background-color: ${theme.color.background.ui04};
  }
`;

const Icon = styled.div`
  margin-bottom: ${theme.spacing.spacing02};

  svg {
    width: 2.7rem;
    height: 2.7rem;
  }
`;

type Props = {
  label?: string;
  icon: ReactNode;
  active?: boolean;
  onClick?: () => void;
};

export function IconBox({ icon, label, active = false, onClick }: Props) {
  return (
    <Wrapper onClick={onClick} type="button" active={active}>
      <Icon>{icon}</Icon>
      <Text size="md" weight="medium" color={theme.color.text.text01}>
        {label}
      </Text>
    </Wrapper>
  );
}
